/* eslint-disable import/prefer-default-export */
export const getReportDetailsColumns = (t, bluePrintId) => [
  {
    label: t('order_submitted__report_number'),
    dataKey: 'reportId',
  },
  {
    label: t('order_submitted__product_type'),
    dataKey: 'product',
  },
  {
    label: t('common_delivery'),
    dataKey: 'delivery',
  },
  ...((bluePrintId === '') ? [
    {
      label: t('order_submitted__address'),
      dataKey: 'address',
    },
    {
      label: t('order_submitted__building_id'),
      dataKey: 'building',
    },
  ]
    : [{ label: t('blueprint_order__blueprint_id'), dataKey: 'building' }]),
];
